<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-10-12 14:21:09
 * @Description: 材质编辑
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <!-- 模型选择树 -->
    <modelCheckTree
      :disabled="modelCheckTreeDisabled"
      :currentNodeItemF="currentSelectedModelItem"
      :multiSelectedItems="multiSelectedItems"
      @multiItems="multiSelected"
      @setCheckedNode="getCheckedNode"
    ></modelCheckTree>
    <div class="position-absolute texture" v-drag>
      <el-row type="flex" align="middle">
        <el-col :span="18">材质编辑</el-col>
        <el-col :span="6" class="tr">
          <span class="iconfont icon-close cur-pointer" @click="closeComponents(false)"></span>
        </el-col>
      </el-row>
      <!-- 材质编辑 -->
      <div class="fz-12 h-100 texture_edit">
        <el-row :gutter="20" class="flex texture_row">
          <el-col :span="6" :offset="0">对象选择</el-col>
          <el-col :span="18" :offset="0">
            <el-select
              v-model="textureFrom.objSelect"
              popper-class="document_select-popper"
              value-key
              size="small"
              clearable
              filterable
              :disabled="disableByTexture"
              @change="selectChange"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex">
          <el-col :span="6" :offset="0">模型颜色</el-col>
          <el-col :span="3" :offset="0">
            <el-color-picker
              v-model="textureFrom.modelColor"
              :disabled="disableByTexture"
              popper-class="document_color_select-popper"
              @change="handleChange('modelColor')"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-input
              :disabled="disableByTexture"
              v-model="textureFrom.modelColor"
              placeholder
              size="mini"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="roughness flex">
          <el-col :span="7" :offset="0">材质透明度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.vague"
              @change="handleChange('vague')"
              :step="1"
              :max="255"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.vague"
              controls-position="right"
              @change="handleChange('vague')"
              :min="0"
              :max="255"
              size="mini"
              :step="1"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex">
          <el-col :span="7" :offset="0">粗糙度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.roughness"
              @change="handleChange('roughness')"
              :step="0.1"
              :max="1"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.roughness"
              controls-position="right"
              @change="handleChange('roughness')"
              :min="0"
              :max="1"
              size="mini"
              :step="0.1"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex">
          <el-col :span="7" :offset="0">金属度</el-col>
          <el-col :span="8" :offset="0">
            <el-slider
              :disabled="disableByTexture"
              v-model="textureFrom.metalness"
              @change="handleChange('metalness')"
              :max="1"
              :step="0.1"
            ></el-slider>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-input-number
              :disabled="disableByTexture"
              v-model="textureFrom.metalness"
              controls-position="right"
              @change="handleChange('metalness')"
              :min="0"
              :max="1"
              :step="0.1"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex m-t-5">
          <el-col :span="4">
            <el-button
              :disabled="disableByTexture"
              class="button-color"
              size="mini"
              type="primary"
              @click="resetChoose"
              >重新选择</el-button
            >
          </el-col>
          <el-col :span="4" :offset="10">
            <el-button
              :disabled="disableByTexture"
              class="button-color"
              size="mini"
              type="primary"
              @click="saveTexture"
              >保存</el-button
            >
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button :disabled="disableByTexture" type="defalut" size="mini" @click="resetTexture"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ApiMixinSystem from '@/assets/js/api/systemParams'
import modelCheckTree from './modelCheckTree'

export default {
  name: 'editTexture',
  mixins: [ApiMixinSystem],
  components: { modelCheckTree },
  props: ['currentCode', 'currentModelItem'],
  watch: {
    currentModelItem(val, oldVal) {
      if (val) {
        this.$nextTick(async () => {
          if (this.isMultiSelected) {
            this.multiSelectedItems = await window.player.Native.ModelTree.getMultiSelectedItems()
          }
          this.currentSelectedModelItem = val
          if (oldVal && !this.isMultiSelected) {
            window.player.Native.ModelTree.restoreItemMaterial([oldVal])
          }
        })
      }
    },
  },
  computed: {
    systemParams() {
      return this.$store.getters.systemParams || []
    },
  },
  data() {
    return {
      currentInfo: {},
      typeList: [
        {
          lable: '1',
          value: '当前对象',
        },
        {
          lable: '2',
          value: '当前材质',
        },
      ],
      textureFrom: {
        objSelect: '当前对象',
        modelColor: '',
        roughness: 0,
        metalness: 0,
        highlight: 0,
        vague: 0,
      },
      currentTexture: {}, // 当前对象
      newTexture: {}, // 当前材质
      predefineColors: [],
      timer: null,
      disableByTexture: true,
      modelCheckTreeDisabled: false, // 模型选择树是否可以点击
      currentNodeInfo: [],
      predefineColorsParams: {},
      currentSelectedModelItem: 0, // 当前选中模型item
      isMultiSelected: false, // 是否多选状态
      multiSelectedItems: [], // 多选模型集合
    }
  },
  methods: {
    // 选择模式切换
    async multiSelected(bool) {
      this.isMultiSelected = bool
      const toolName = bool ? 'system.ToolMultiSelect' : 'system.Pickup'
      window.player.Native.Tools.setCurrentTool(toolName)
    },
    /**
     * @description: 获取当前选中的节点
     * @param {Array} data
     * @return {*}
     */

    getCheckedNode(data) {
      this.currentNodeInfo = _.map(data, 'item')
      this.disableByTexture = false
      this.modelCheckTreeDisabled = true
      this.setTextureData()
    },
    /**
     * @description:对象选择变化
     * @param {*}
     * @return {*}
     */

    selectChange(row) {
      if (row === '当前对象') {
        this.textureFrom = { ...this.textureFrom, ...this.currentTexture }
      } else {
        this.textureFrom = { ...this.textureFrom, ...this.newTexture }
      }
      if (this.isMultiSelected) {
        window.player.Native.Tools.setCurrentTool('system.Browse')
        window.player.Native.ModelTree.setSelectItem(0)
      }
      this.handleChange()
    },
    updateSystemParams() {
      const params = [
        {
          id: this.predefineColorsParams.id || null,
          parameterValue: this.predefineColors.join(','),
          remark: this.predefineColorsParams.remark || null,
          parentId: this.predefineColorsParams.parentId || null,
          parameterType: this.predefineColorsParams.parameterType,
          parameterCode: this.predefineColorsParams.parameterCode || null,
          parameterName: this.predefineColorsParams.parameterName || null,
        },
      ]
      this.apiSystemParams({
        method: 'updateSystemParams',
        params,
      }).then((res) => {
        if (res.success) {
          // 更新系统参数 vuex
          this.updateCommonSystemList()
        }
      })
    },
    async updateCommonSystemList() {
      const systemParamsRes = await this.apiSystemParams({
        method: 'getSystem',
        params: {
          dataPage: {
            pageSize: 999,
          },
        },
      })
      if (systemParamsRes && systemParamsRes.success) {
        this.$store.dispatch('systemParams', systemParamsRes.dataList)
      }
    },
    /**
     * @description: 通知模型更新材质
     * @param {*}
     * @return {*}
     */

    handleChange(val) {
      if (
        val === 'modelColor' &&
        this.predefineColors.indexOf(this.textureFrom.modelColor) === -1
      ) {
        // 颜色变化，且系统参数中不含有该颜色，更新系统参数中的数据
        this.predefineColors.unshift(this.textureFrom.modelColor)
        this.predefineColors =
          this.predefineColors.length > 10
            ? this.predefineColors.slice(0, 20)
            : this.predefineColors
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(async () => {
        // 更新材质
        const color = this.hex2rgb(this.textureFrom.modelColor)
        color.a = Number((this.textureFrom.vague / 255).toFixed(4))
        const query = {
          items: this.currentNodeInfo,
          editMode: this.textureFrom.objSelect === '当前对象' ? 1 : 2,
          matParam: {
            name: this.textureFrom.name,
            matIndex: this.textureFrom.matIndex,
            color,
            metalness: this.textureFrom.metalness,
            roughness: this.textureFrom.roughness,
          },
        }
        await window.player.Native.ModelTree.updateItemMaterial(
          query.items,
          query.editMode,
          query.matParam
        )
      }, 500)
    },
    /**
     * @description: 保存材质
     * @param {*}
     * @return {*}
     */

    async saveTexture() {
      const modelList = await window.player.Native.Model.getAllInfo()
      const res = await window.player.Native.Model.saveItemMaterial(Object.keys(modelList)[0])
      if (res) {
        this.$message.success('保存材质成功！')
        // 加载模型材质文件
        window.player.Native.Model.loadItemMaterial(Object.keys(modelList)[0])
      } else {
        this.$message.warning('保存材质失败！')
        await window.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
      }

      console.log(res, Object.keys(modelList)[0], 'aaaaaaaaaaaa')
      this.multiSelected(this.isMultiSelected)
      this.disableByTexture = true
      this.modelCheckTreeDisabled = false
    },
    /**
     * @description: 重置材质
     * @param {*}
     * @return {*}
     */

    resetTexture() {
      this.textureFrom = this.$options.data().textureFrom
      this.selectChange(this.textureFrom.objSelect)
    },
    /**
     * @description: 重新选择
     * @param {*}
     * @return {*}
     */

    async resetChoose() {
      this.multiSelected(this.isMultiSelected)
      await window.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
      this.textureFrom = this.$options.data().textureFrom
      this.disableByTexture = true
      this.modelCheckTreeDisabled = false
    },
    /**
     * @description: 关闭弹框
     * @param {*} val
     * @return {*}
     */

    closeComponents(val) {
      this.$emit('closeComponents', val)
    },
    async setTextureData() {
      this.textureFrom = this.$options.data().textureFrom
      this.typeList = this.$options.data().typeList
      // 获取当前节点的材质
      let currentNodeTexture = await PlayerUtils.call(
        window.player.Native.ModelTree.fetchItemMaterial,
        this.currentNodeInfo,
        1 + 2
      )
      currentNodeTexture = _.map(currentNodeTexture, (res) => {
        const modelColor = this.rgb2hex(
          `rgb(${res.color.r * 255},${res.color.g * 255},${res.color.b * 255})`
        )
        return {
          matIndex: res.matIndex,
          name: res.name,
          modelColor,
          vague: res.color.a * 255,
          roughness: res.roughness,
          metalness: res.metalness,
        }
      })
      if (currentNodeTexture[1].matIndex >> 1 === -1) {
        this.typeList = [
          {
            lable: '1',
            value: '当前对象',
          },
        ]
      }
      this.currentTexture = currentNodeTexture[0]
      this.newTexture = currentNodeTexture[1]
      this.selectChange(this.textureFrom.objSelect)
    },
    /**
     * @description: rgb与16进制转化
     * @param {*} rgb
     * @return {*}
     */

    rgb2hex(rgb) {
      const reg = /^((rgb|RGB)\(\d+),\s*(\d+),\s*(\d+)\)$/
      if (!reg.test(rgb)) return ''
      const rgbArr = rgb.slice(4, -1).split(',')
      const resultArr = _.map(rgbArr, (item) => {
        if (+item > 16) return (+item).toString(16)
        return `0${(+item).toString(16)}`
      })
      return `#${resultArr.join('')}`
    },
    /**
     * @description: hex转化成rgb
     * @param {*} hex
     * @return {*}
     */

    hex2rgb(hex) {
      const result = {}
      result.r = Number((parseInt(hex.substring(1, 3), 16) / 255).toFixed(4))
      result.g = Number((parseInt(hex.substring(3, 5), 16) / 255).toFixed(4))
      result.b = Number((parseInt(hex.substring(5), 16) / 255).toFixed(4))
      return result
    },
  },
  created() {
    this.predefineColorsParams =
      _.find(this.systemParams, { parameterCode: 'PredefineColors' }) || ''
    if (this.predefineColorsParams && this.predefineColorsParams.parameterValue) {
      this.predefineColors = this.predefineColorsParams.parameterValue.split(',')
    } else {
      this.predefineColors = []
    }
  },
  async beforeDestroy() {
    // 更新系统参数 vuex
    this.updateSystemParams()
    if (!_.isEmpty(this.currentNodeInfo)) {
      await window.player.Native.ModelTree.restoreItemMaterial(this.currentNodeInfo)
    }
  },
}
</script>
<style lang="scss" scoped>

.texture {
  width: 368px;
  right: 0px;
  padding: 10px;
  height: 18rem;
  top: 45px;
  z-index: 1000;
  background-color: #dbe1e4 !important;
  &_edit {
    padding: 10px !important;
    background-color: #fff !important;
    height: calc(100% - 25px);
    border-radius: 2px;
  }
}
/deep/.el-row {
  align-items: center;
}
/deep/.el-input-number--mini {
  width: 100px;
}
.roughness {
  /deep/.el-slider__runway {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0) 0, #fff);
  }
}
/deep/ .el-color-picker {
  height: 30px;
}

</style>
